export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9017.57a74b0b.jpg";